import * as React from "react";
import { memo } from "react";

const SvgKeyboard = (props) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 20 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.155 0C.518 0 0 .49 0 1.09v10.04c0 .6.518 1.09 1.155 1.09h17.69c.637 0 1.155-.486 1.155-1.09V1.09C20 .49 19.482 0 18.845 0H1.155Zm0 1h17.69c.098 0 .155.057.155.09v10.04c0 .037-.061.09-.155.09H1.155c-.094 0-.155-.053-.155-.09V1.09c0-.037.061-.09.155-.09Zm2.45 1.837a.624.624 0 1 0-.001 1.248.624.624 0 0 0 0-1.248Zm2.558 0a.624.624 0 1 0 0 1.248.624.624 0 0 0 0-1.248Zm2.555 0a.625.625 0 1 0 0 1.25.625.625 0 0 0 0-1.25Zm2.56 0a.624.624 0 1 0 0 1.249.624.624 0 0 0 0-1.25Zm2.559 0a.625.625 0 1 0 0 1.249.625.625 0 0 0 0-1.25Zm2.559 0a.625.625 0 1 0 0 1.25.625.625 0 0 0 0-1.25ZM4.886 5.486a.625.625 0 1 0 0 1.25.625.625 0 0 0 0-1.25Zm2.555 0a.624.624 0 1 0 0 1.248.624.624 0 0 0 0-1.248Zm2.559 0a.624.624 0 1 0 0 1.248.624.624 0 0 0 0-1.248Zm2.555 0a.625.625 0 1 0 0 1.249.625.625 0 0 0 0-1.25Zm2.56 0a.625.625 0 1 0 0 1.249.625.625 0 0 0 0-1.25ZM5.537 8.26a.502.502 0 1 0 0 1.004h8.923a.502.502 0 1 0 0-1.004H5.538Z"
      fill="#000"
    />
  </svg>
);

const Memo = memo(SvgKeyboard);
export default Memo;
